import { useCallback } from 'react';
import { useHistory } from 'react-router-dom';

export type NavigateFunction = (to: string, options?: { replace?: boolean }) => void;

/**
 * Programmatic navigation with the signature of react-router v6's `useNavigate`. The returned
 * function is stable across renders, so it is safe in effect dependencies and long-lived listeners.
 */
const useNavigate = (): NavigateFunction => {
  const history = useHistory();

  return useCallback<NavigateFunction>(
    (to, { replace = false } = {}) => {
      if (replace) history.replace(to);
      else history.push(to);
    },
    [history],
  );
};

export default useNavigate;
